import type { Router } from '@angular/router';
import type { AuthService } from '../services/auth.service';

/**
 * サインアウトしてログインへ。signOut 失敗で session が残るときは遷移しない
 *（ガードで `/` ↔ login のループを避ける）。
 */
export async function signOutToLogin(opts: {
  router: Router;
  authService: AuthService;
  replaceUrl?: boolean;
}): Promise<boolean> {
  const replaceUrl = opts.replaceUrl !== false;
  await opts.authService.signOut();
  if (opts.authService.session() != null) return false;
  await opts.router.navigate(['/auth/login'], { replaceUrl });
  return true;
}

/**
 * 未所属時の行き先。
 * 永続アカウント → コミュニティ作成。匿名 → サインアウトしてログインへ。
 */
export async function navigateWhenNoCommunity(opts: {
  router: Router;
  authService: AuthService;
  replaceUrl?: boolean;
}): Promise<false> {
  const replaceUrl = opts.replaceUrl !== false;
  if (opts.authService.isAnonymous()) {
    await signOutToLogin({ ...opts, replaceUrl });
    return false;
  }
  await opts.router.navigate(['/communities/create'], { replaceUrl });
  return false;
}
